import { Controller } from '@hotwired/stimulus'

export default class ToggleSidebarController extends Controller {
  static targets = ['button', 'sidebar'];

  connect() {
    window.addEventListener('click', (e) => {
      if (!this.sidebarTarget.contains(e.target)) {
        this.closeSidebar();
      }
    });
  }

  openSidebar() {
    this.sidebarTarget.classList.add('extended-sidebar');
  }

  closeSidebar() {
    this.sidebarTarget.classList.remove('extended-sidebar');
  }
}
